import {AxiosResponse} from "axios";
import axios from "./axios";
import AuthenticateUser from "../domain/AuthenticateUser";
import SessionRequest from "../domain/endpoint/SessionRequest";
import Poller from "../domain/poller/Poller";
import PollerPayload from "../domain/poller/PollerPayload";
import PollControllerBase from "./PollControllerBase";

export default class SessionController extends PollControllerBase {
    public static getSession(authenticateUser: AuthenticateUser, bnsToken: string, selectedOrganizationId: number| null, enforceNewSession: boolean = false) {
        const sessionRequest = new SessionRequest(authenticateUser, bnsToken, selectedOrganizationId, enforceNewSession);
        const payload = new PollerPayload((currentAttempt: number) => {
            return new Promise((resolve, reject) => {
                sessionRequest.attempt = currentAttempt;
                axios.post("/session", sessionRequest)
                    .then((data: AxiosResponse) => {
                        resolve(data.data);
                    })
                    .catch((err: any) => {
                        reject(err);
                    });
            });
        }, this.validator, 1000, 10, null);
        return (new Poller(payload)).execute();
    }
}

